'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsShallowCompare = require('react-addons-shallow-compare');

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _fontFamilies = require('constants/fontFamilies');

var _fontFamilies2 = _interopRequireDefault(_fontFamilies);

var _components = require('components');

var _FontFamilyPicker = require('./FontFamilyPicker.scss');

var _FontFamilyPicker2 = _interopRequireDefault(_FontFamilyPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FontFamilyPicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FontFamilyPicker, _Component);

  function FontFamilyPicker(props) {
    (0, _classCallCheck3.default)(this, FontFamilyPicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FontFamilyPicker.__proto__ || (0, _getPrototypeOf2.default)(FontFamilyPicker)).call(this, props));

    _this._onChange = function (event) {
      var onChange = _this.props.onChange;

      var value = event.target && event.target.value;

      _this.setState({ value: value });
      if (onChange) onChange(event);
    };

    _this.state = {
      options: props.options,
      value: null
    };
    return _this;
  }

  (0, _createClass3.default)(FontFamilyPicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.options !== this.props.options || nextProps.value !== this.props.value) {
        this.setState({ options: nextProps.options, value: nextProps.value });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var options = this.state.options;
      var classNameOption = this.props.classNameOption;


      return options.map(function (option) {
        return _react2.default.createElement(
          'option',
          {
            className: (0, _classnames2.default)(classNameOption, _FontFamilyPicker2.default.option),
            key: option.key,
            value: option.value,
            style: { fontFamily: option.value }
          },
          option.description
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          className = _props.className,
          options = _props.options,
          classNameOption = _props.classNameOption,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'options', 'classNameOption']);


      return _react2.default.createElement(
        _components.EnterpriseDropDown,
        (0, _extends3.default)({}, rest, {
          className: (0, _classnames2.default)(className, _FontFamilyPicker2.default.root),
          style: { fontFamily: this.props.value },
          onChange: this._onChange
        }),
        this._renderOptions()
      );
    }
  }]);
  return FontFamilyPicker;
}(_react.Component), _class.propTypes = {
  options: _react.PropTypes.array,
  value: _react.PropTypes.string,

  // CALLBACKS
  onChange: _react.PropTypes.func,

  // CLASS NAMES
  className: _react.PropTypes.string,
  classNameOption: _react.PropTypes.string
}, _class.defaultProps = {
  options: _fontFamilies2.default,
  value: _fontFamilies.DEFAULT && _fontFamilies.DEFAULT.value,
  onChange: function onChange() {}
}, _temp);
exports.default = FontFamilyPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/FontFamilyPicker/FontFamilyPicker.jsx
// module id = 1574
// module chunks = 0